import * as types from '../constants/loyalty';
import api from '../api';
import hydrateVErrors from '../utils/vErrors';

export const setVErrors = payload => ({
  type: types.SET_V_ERRORS,
  payload,
});

const setLoader = bool => dispatch =>
  dispatch({
    type: types.SET_LOADER,
    payload: bool,
  });

export const storeLoyalty = payload => async dispatch => {
  try {
    dispatch({ type: types.STORE_LOYALTY_START });
    let response = await api.post(`/loyalty-program`, payload);
    dispatch({ type: types.STORE_LOYALTY_SUCCESS, payload: payload });
    return response;
  } catch (ex) {
    dispatch({ type: types.STORE_LOYALTY_FAILURE, payload: ex });
    dispatch(setVErrors(hydrateVErrors(ex)));
    return ex.response;
  }
};

export const confirmPhone = payload => async dispatch => {
  try {
    dispatch({ type: types.CONFIRM_PHONE_START });
    let { data } = await api.post(`/confirmation-code`, payload);
    dispatch({ type: types.CONFIRM_PHONE_SUCCESS, payload: data.code });

    return data;
  } catch (ex) {
    dispatch({ type: types.CONFIRM_PHONE_FAILURE, payload: ex });
    dispatch(setVErrors(hydrateVErrors(ex)));

    throw ex;
  }
};

export const loyaltyMessage = payload => async dispatch => {
  dispatch({ type: types.UPDATE_MESSAGE, payload });
};

export const confirm = payload => async dispatch => {
  try {
    dispatch(setLoader(true));
    const res = await api.post('/loyalty-program/confirm', {
      _method: 'PATCH',
      ...payload,
    });
    dispatch(setLoader(false));
    return res;
  } catch (e) {
    console.error(e);
    return e.response;
  }
};
